/** 市场情绪 Tab：恐慌指数自动刷新间隔 */
export const FNG_REFRESH_MS = 60 * 60 * 1000 // 1 小时

export const ETF_TYPE_COLORS: Record<string, string> = {
  'us-btc-spot': '#f7931a',
  'us-eth-spot': '#627eea',
  'us-sol-spot': '#14f195',
}

export function formatUsdCompact(value: number): string {
  const sign = value > 0 ? '+' : value < 0 ? '' : ''
  const abs = Math.abs(value)
  if (abs >= 1e9) return `${sign}$${(value / 1e9).toFixed(2)}B`
  if (abs >= 1e6) return `${sign}$${(value / 1e6).toFixed(2)}M`
  if (abs >= 1e3) return `${sign}$${(value / 1e3).toFixed(1)}K`
  return `${sign}$${value.toFixed(0)}`
}

export function etfFlowColor(net: number): string {
  if (net > 0) return '#3f8600'
  if (net < 0) return '#cf1322'
  return '#8c8c8c'
}
